export const getCheckedSettings = ( state ) => state.checkedSettings
export const getCampaignSettings = ( state ) => state.campaignSettings


// WEBPACK FOOTER //
// ./src/app/adobeAcrobat/vuex/getters.js